import React, { FC } from 'react'
import { Box, makeStyles, Tooltip } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

const useCarrierTooltipStyles = makeStyles(theme => ({
  tooltipPopper: {
    '& .MuiTooltip-tooltip': {
      padding: theme.spacing(2),
      backgroundColor: brandColors.black,
    },
    '& ul, & h3': {
      color: brandColors.white,
    },
  },
}))

interface ICarrierTooltipProps {
  /**
   * Content to be displayed on the tooltip
   */
  children: string | JSX.Element
  /**
   * Is the tooltip visible?
   */
  open: boolean
  /**
   * A callback to execute when the the component wants to trigger the close of
   * the tooltip
   */
  onClose: () => void
}

export const CarrierTooltip: FC<ICarrierTooltipProps> = ({ children, onClose, open }) => {
  const classes = useCarrierTooltipStyles()

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  return (
    <Tooltip
      classes={{
        popper: classes.tooltipPopper,
      }}
      PopperProps={{
        disablePortal: true,
      }}
      onClose={handleClose}
      open={open}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={children}>
      <Box />
    </Tooltip>
  )
}
